export const FilePickerStyles = {
  filePicker: {
    '& .file-picker-row': {
      '& .picker-row': {
        display: 'flex',
        alignItems: 'center',
      },
      '& + .file-picker-row': {
        marginTop: 8,
      },
    },
    '& .file-picker-action-message': {
      position: 'absolute',
      left: '-9999px',
      width: '1px',
      height: '1px',
    },
    '& .file-picker-error': {
      '& .file-picker-file-name': {
        borderColor: '#D90026',
        color: '#D90026',
        backgroundColor: '#FFEBEB',
      },
    },
    '& .file-picker-file-name': {
      flex: '1 1 100%',
      color: '#605E5C',
      marginRight: '8px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .file-picker-explore-btn': {
      flex: '0 0 auto',
    },
    '& .file-picker-remove-btn': {
      flex: '0 0 auto',
      border: 'none',
      position: 'relative',
      height: 25,
      fontWeight: 'normal',
      display: 'flex',
      alignItems: 'center',
      color: '#0078d4',
      '&-icon': {
        marginRight: 8,
        display: 'block',
        lineHeight: 1,
      },
      '&:hover': {
        color: '#004578',
      },
      '&.btn.btn-link': {
        marginLeft: 0,
      },
    },
    '& button.file-picker-add-new': {
      marginTop: 8,
      border: 'none',
      backgroundColor: 'transparent !important',
      paddingLeft: 0,
      display: 'flex',
      alignItems: 'center',
      '&:hover &-text': {
        textDecoration: 'underline',
      },
      '& .file-picker-add-new-icon': {
        marginRight: 8,
        lineHeight: 1,
        top: 0,
      },
      '& .file-picker-add-new-text': {
        fontWeight: 'normal',
      },
      '&:not([disabled])': {
        color: '#0078d4',
        '&:hover': {
          color: '#004578',
        },
      },
    },
  },
};
